export enum FormRequestSteps {
    SEARCH_CLIENT       = 0,
    SELECT_CONTACT      = 1,
    SELECT_CHANNEL      = 2,
    SELECT_FORM         = 3,
    SELECT_PATIENT      = 4,
    PREFILL_FIELDS      = 5,
    UPDATE_PAYMENT_INFO = 6,
    SELECT_SITE         = 7
}